import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import * as Icons from "lucide-react";
import { SERVICES } from "../../data/content";
import { slugForServiceName } from "../../data/servicePages";
import { GarageNote } from "../GarageNote";

export const ServiceCard = ({ service }) => {
  const Icon = Icons[service.icon] || Icons.Wrench;
  const slug = slugForServiceName(service.name);
  const inner = (
    <>
      <div className="bg-blue-600/10 border border-blue-500/20 rounded-sm w-11 h-11 flex items-center justify-center mb-5">
        <Icon className="h-5 w-5 text-blue-500" />
      </div>
      <h3 className="font-heading text-lg font-semibold text-white mb-2">{service.name}</h3>
      <p className="text-zinc-400 text-sm leading-relaxed">{service.desc}</p>
      {slug && <span className="inline-flex items-center gap-1 text-blue-400 text-xs font-semibold mt-4">Learn more <ArrowRight className="h-3 w-3" /></span>}
    </>
  );
  const cls = "block bg-[#121212] border border-zinc-800 rounded-xl p-6 sm:p-8 hover:-translate-y-1 hover:border-blue-500/50 transition-[transform,border-color] duration-300";
  const tid = `service-card-${service.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`;
  return slug ? (
    <Link data-testid={tid} to={`/services/${slug}`} className={cls}>{inner}</Link>
  ) : (
    <div data-testid={tid} className={cls}>{inner}</div>
  );
};

const HOME_PREVIEW = [
  "Engine Diagnostics", "Brake Pads & Rotors", "Battery Replacement", "Starter Replacement",
  "Alternator Repair", "Tune-Ups & Maintenance", "Pre-Purchase Inspections", "Oil Change Service",
];

export const ServicesPreview = () => (
  <section className="py-24 sm:py-32 border-b border-zinc-800/60" data-testid="services-preview-section">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
        <div className="max-w-2xl">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-blue-500">What We Fix</span>
          <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-none text-white mt-4">
            Mobile Auto Repair — {SERVICES.length} Services, One Driveway: Yours.
          </h2>
          <p className="text-zinc-400 leading-relaxed mt-5">
            From vehicle diagnostics and check engine light diagnostics to no-start
            troubleshooting, brake pads and rotors, battery, starter and alternator
            replacement, tune-ups and pre-purchase inspections — our mobile mechanics
            handle it all at your location.
          </p>
        </div>
        <Link
          data-testid="view-all-services-link"
          to="/services"
          className="inline-flex items-center gap-2 text-blue-400 hover:text-blue-300 font-semibold shrink-0"
        >
          View all {SERVICES.length} services <ArrowRight className="h-4 w-4" />
        </Link>
      </div>

      <div className="mb-12"><GarageNote /></div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {HOME_PREVIEW.map((name) => SERVICES.find((s) => s.name === name)).filter(Boolean).map((s) => (
          <ServiceCard key={s.name} service={s} />
        ))}
      </div>
    </div>
  </section>
);
